import theme from '@theme';
import React, { CSSProperties } from 'react';
import renderSkeletons from './renderSkeltons';

const SkeletonContent: React.FC = () => {
  const skeletonData = [
    { width: 23, height: 23, baseColor: theme.palette.grey[200], borderRadius: 100 },
    {
      width: 138,
      height: 8,
      baseColor: theme.palette.grey[200],
      borderRadius: 5,
      className: 'mx-2'
    }
  ];

  return (
    <>
      {renderSkeletons(skeletonData)}
      <SkeletonDetails />
    </>
  );
};

const SkeletonDetails: React.FC = () => {
  const skeletonData = [
    {
      width: 4,
      height: 4,
      baseColor: theme.palette.grey[200],
      borderRadius: 100,
      className: 'mx-1',
      style: { position: 'relative' as CSSProperties['position'], top: '-2px' }
    },
    {
      width: 83,
      height: 17,
      baseColor: theme.palette.grey[200],
      borderRadius: 5,
      className: 'mx-2'
    }
  ];

  return <>{renderSkeletons(skeletonData)}</>;
};

const IdentityHeaderSkelton = { SkeletonContent, SkeletonDetails };

export default IdentityHeaderSkelton;
